<template lang="html">
    <div>
        <div class="cursor card border rounded mb-3 mt-3 hover-border-primary" 
        v-for="item in filteredConsultants" 
        :class="{'selected':item.uid == $store.state.selected_consultant_uid}" @click="select(item)">
                <div class="row g-0">
                    <div class="col-auto position-relative">
                        <img :src="backendMediaUrl + item.avatar" class="rounded-start sh-6 sw-6" alt="thumb">
                        <span class="position-absolute start-100 translate-middle badge rounded-pill bg-danger" style="z-index: 1">{{ item.unread_notifications_count }}</span>
                    </div>
                    <div class="col p-1">
                        <div class="card-body d-flex flex-row pt-0 pb-0 ps-3 pe-0 h-100 align-items-center justify-content-between">
                            <div class="row">
                                <!-- class="name" and class="position" provides the data -->

                                <div class="col-4 d-flex align-items-center text-primary"><b>{{item.fullname}}</b></div>
                                <div class="col-8 d-flex" v-if="stats">
                                    <div class="col-auto text-center me-2">
                                        <div class="text-small text-uppercase text-muted">Positifs</div>
                                        <div class="text-success">
                                            {{get_stat('positives_count', item)}}
                                        </div>
                                    </div>
                                    <div class="col-auto text-center mx-2">
                                        <div class="text-small text-uppercase text-muted">Négatifs</div>
                                        <div class="text-danger">
                                            {{get_stat('negatives_count', item)}}
                                        </div>
                                    </div>
                                    <div class="col-auto text-center mx-2">
                                        <div class="text-small text-uppercase text-muted">Infos</div>
                                        <div class="text-warning">
                                            {{get_stat('informationneeded_count', item)}}
                                        </div>
                                    </div>
                                    <div class="col-auto text-center mx-2">
                                        <div class="text-small text-uppercase text-muted">Validés</div>
                                        <div class="text-info">
                                            {{get_stat('validated_count', item)}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</template>

<script>
import settings from "@/settings.coffee";
import CONSULTANT_SET_WITH_COUNT from '@/gql/queries/consultantSetWithCount.graphql';
import { gqlQuery } from '@/gqlClient.js';

export default {
  name: 'ConsultantList',
  props: {
    msg: String,
    searchQuery: String
  },
  data() {
    return {
      style: {},
      consultants: [],
      backendMediaUrl: settings.backendMediaUrl,
      stats: this.$store.state.stats
    };
  },
  computed: {
    filteredConsultants() {
      // Vérifier que searchQuery est une chaîne de caractères et n'est pas vide
      if (this.searchQuery === "") {
        return this.consultants;
      }
      // Filtrer les consultants en s'assurant que fullname est défini
      return this.consultants.filter(consultant =>
        consultant &&
        consultant.fullname &&
        consultant.fullname.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    }
  },
  methods: {
    select(item) {
      this.$router.push({ name: "manage", params: { uid: item.uid } });
      this.$store.commit("select_consultant", item.uid);
    },
    get_stat(key, item) {
      let clt_stat = null;
      for (let current of this.stats) {
        if (current.consultant_id === item.uid) {
          clt_stat = current[key];
        }
      }
      return clt_stat;
    }
  },
  async mounted() {
    const res = await gqlQuery(CONSULTANT_SET_WITH_COUNT, {});
    this.consultants = res.body.data.consultant_set || [];
    if (this.$route.params && this.$route.params.uid) {
      this.$store.commit("select_consultant", this.$route.params.uid);
    }
  },
  beforeDestroy() {
    this.$store.commit("select_consultant", null);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

.list-item:hover {
    cursor: pointer;
}
.selected {
    background-color: #eee;
    border-radius:0.25rem;
}

</style>
